const roles = {
  user: 'User',
  coach: 'Coach',
  admin: 'Admin',
  superAdmin: 'SuperAdmin',
};

export default roles;
